import {
  FormControl,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
} from '@chakra-ui/react';
import { Form, Formik } from 'formik';
import React, { useState } from 'react';
import Lightbox from 'react-image-lightbox';

import Button from 'components/Button';
import { FormikTextArea } from 'components/Formik';
import { IImageData } from 'containers/EmployeeTimeClock/ClockedInDetail/ClockedInDetail';
import {
  captionFormValidationSchema,
  initialCaptionFormData,
} from 'containers/EmployeeTimeClock/ClockedInDetail/schema';

interface IProps {
  image: IImageData;
  mutateImage: (image: IImageData) => void;
  closeSlider: () => void;
}

const ImageSlider: React.FC<IProps> = ({ image, mutateImage, closeSlider }) => {
  const [captionFormValues, setCaptionFormValues] = useState<object>(initialCaptionFormData);

  const { isOpen, onOpen, onClose } = useDisclosure();

  const onAddCaption = () => {
    setCaptionFormValues(initialCaptionFormData);
    onOpen();
  };

  const onEditCaption = () => {
    setCaptionFormValues({ caption: image.caption });
    onOpen();
  };

  const onCaptionSave = (data?: any) => {
    const toAddCaption = data.caption;
    image.caption = toAddCaption;
    mutateImage(image);
    onClose();
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Add Caption</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <Formik
              initialValues={captionFormValues}
              validationSchema={captionFormValidationSchema}
              onSubmit={onCaptionSave}
            >
              {() => (
                <Form noValidate>
                  <FormControl mt={2}>
                    <FormikTextArea name="caption" label="Caption" />
                  </FormControl>
                  <Button mr={3} type="submit">
                    Save
                  </Button>
                  <Button onClick={onClose} variant="ghost">
                    Cancel
                  </Button>
                </Form>
              )}
            </Formik>
          </ModalBody>
        </ModalContent>
      </Modal>
      <Lightbox
        mainSrc={image.src}
        toolbarButtons={
          image.caption === ''
            ? [
                <Button variant="solid" size="sm" onClick={onAddCaption}>
                  Add Caption
                </Button>,
              ]
            : [
                <Button variant="solid" size="sm" onClick={onEditCaption}>
                  Edit Caption
                </Button>,
              ]
        }
        imageCaption={image.caption}
        onCloseRequest={closeSlider}
      />
    </>
  );
};
export default ImageSlider;
